import {
  Box,
  Button,
  Flex,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  useToast,
  HStack,
  Text,
} from "@chakra-ui/react"
import axios from "axios"
import { useEffect, useState } from "react"
import { api } from "config"

export default function Topics() {
  const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [topics, setTopics] = useState<any[]>([])
  const [code, setCode] = useState("")
  const [name, setName] = useState("")
  const [editId, setEditId] = useState<number | null>(null)

  const loadTopics = async () => {
    const res = await axios.get(`${api}/topics`, {
      withCredentials: true,
    })
    setTopics(res.data)
  }

  useEffect(() => {
    loadTopics()
  }, [])

  const openCreate = () => {
    setEditId(null)
    setCode("")
    setName("")
    onOpen()
  }

  const openEdit = (t: any) => {
    setEditId(t.id)
    setCode(t.Code)
    setName(t.Name)
    onOpen()
  }

  const handleSave = async () => {
    try {
      if (editId) {
        await axios.put(`${api}/topics/${editId}`, { Code: code, Name: name })
        toast({ title: "Topic updated", status: "success" })
      } else {
        await axios.post(
          `${api}/topics`,
          { Code: code, Name: name },
          { withCredentials: true },
        )
        toast({ title: "Topic created", status: "success" })
      }
      onClose()
      loadTopics()
    } catch {
      toast({ title: "Save failed", status: "error" })
    }
  }

  const handleDelete = async (id: number) => {
    await axios.delete(`${api}/topics/${id}`, {
      withCredentials: true,
    })
    toast({ title: "Topic deleted", status: "success" })
    loadTopics()
  }

  return (
    <Box p={5} boxShadow="md" bg="white" borderRadius="md">
      <Button colorScheme="blue" mb={4} onClick={openCreate}>
        + Add Topic
      </Button>

      <Table variant="simple">
        <Thead bg="gray.100">
          <Tr>
            <Th>Code</Th>
            <Th>Topic Name</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {topics.length ? (
            topics.map((t) => (
              <Tr key={t.id}>
                <Td>{t.Code}</Td>
                <Td>{t.Name}</Td>
                <Td>
                  <HStack>
                    <Button
                      size="sm"
                      colorScheme="yellow"
                      onClick={() => openEdit(t)}
                    >
                      Edit
                    </Button>
                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={() => handleDelete(t.id)}
                    >
                      Delete
                    </Button>
                  </HStack>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={3} textAlign="center" py={10} color="gray.500">
                No Topics Yet
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{editId ? "Edit Topic" : "Add Topic"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontSize="sm" mb={1}>
              Code
            </Text>
            <Input
              mb={3}
              placeholder="Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <Text fontSize="sm" mb={1}>
              Topic Name
            </Text>
            <Input
              placeholder=" Topic Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="blue" onClick={handleSave}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
